import styled from 'styled-components';

export const GoStreakDetailsWrapper = styled.div(
  props => `
    background:${props.theme.colors.goWhite.base};
    border-radius: 0.8rem;
    margin-bottom: 1.8rem;
    overflow: hidden;
      `,
);

export const GoStreakDetailsHeaderWrapper = styled.div(
  props => `
    background:${props.theme.colors.goWhite.base};
    padding: 1rem 1.2rem;
    display: flex;
    align-items:center;
    justify-content: space-between;
    .headerText {
      display: flex;
      align-items:center;
          font-weight: 600;
      font-size: 1.2rem;
      color: #FF554A;
    }
      `,
);

export const GoStreakDetailsContentWrapper = styled.div(
  props => `
    padding: 1rem 0.8rem 1.2rem;
    display: flex;
    align-items:center;
    background: linear-gradient(108.86deg, #FFEDE8 12.46%, #FFFFFF 107.49%);
    cursor: pointer;
  `,
);

export const InnerLeftWrapper = styled.div(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    align-items:center;
      `,
);

export const InnerRightWrapper = styled.div(
  props => `
  display: flex;
    align-items:center;
    flex: 1;
  .textWrapper {
    flex-grow: 1;
  } 
    
    .headerText  {
      font-weight: 600;
      font-size: 1.3rem;
      color: #623D3F;
    }

    .descText {
      padding-top: 0.2rem;
      font-size: 1.2rem;
      color: ${props.theme.colors.downriver.dark};
    }
      `,
);
